export default {
    namespaced: true,
    state: {
        client_id: 0,
        client_name: '',
        user_name: '',
        loginuser_id: 0,
        email: '',
        link_company_limit: 0,
        plan_kind_name: '',
        trial_plan_kind_name: '',
        required_change_password: false
    },
    mutations: {
        // ユーザー基本情報をセット
        setUserBasicInformation(state, user_basic_information) {
            state.client_id = user_basic_information.hasOwnProperty('client_id') ? user_basic_information.client_id : 0;
            state.client_name = user_basic_information.hasOwnProperty('client_name')
                ? user_basic_information.client_name
                : 0;
            state.user_name = user_basic_information.hasOwnProperty('user_name') ? user_basic_information.user_name : 0;
            state.loginuser_id = user_basic_information.hasOwnProperty('loginuser_id')
                ? user_basic_information.loginuser_id
                : 0;
            state.email = user_basic_information.hasOwnProperty('email') ? user_basic_information.email : '';
            state.link_company_limit = user_basic_information.hasOwnProperty('link_company_limit')
                ? user_basic_information.link_company_limit
                : 0;
            state.plan_kind_name = user_basic_information.hasOwnProperty('plan_kind_name') ? user_basic_information.plan_kind_name : '';
            state.trial_plan_kind_name = user_basic_information.hasOwnProperty('trial_plan_kind_name') ? user_basic_information.trial_plan_kind_name : '';
            state.required_change_password = user_basic_information.hasOwnProperty('required_change_password') ? user_basic_information.required_change_password : '';
        }
    },
    actions: {},
    getters: {
        // クライアントIDを取得
        getClientId(state) {
            return state.client_id;
        },
        // クライアント名を取得
        getClientName(state) {
            return state.client_name;
        },
        // ユーザー名を取得
        getUserName(state) {
            return state.user_name;
        },
        // ユーザーIDを取得
        getLoginuserId(state) {
            return state.loginuser_id;
        },
        // メールアドレスを取得
        getEmail(state) {
            return state.email;
        },
        // 企業属性付与の上限数を取得
        getLinkCompanyLimit(state) {
            return state.link_company_limit;
        },
        // プラン名を取得
        getPlanKindName(state) {
            return state.plan_kind_name;
        },
        // トライアル中のプラン名を取得
        getTrialPlanKindName(state) {
            return state.trial_plan_kind_name;
        },
    }
};
